<div mat-dialog-title>
  <h4>{{ 'properties.documents.downloadDialog.title' | translate }}
    <!-- <span [ngClass]="{ 'd-none': !model.subject }"> - {{ model.subject }}</span> -->
  </h4>
  <div class="text-muted dialog-subtitle">
    {{ 'properties.documents.downloadDialog.subtitle' | translate }}
  </div>
</div>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
      <div class="row mb-1">
        <!-- With "Scarica tutti" the two buttons sit at opposite ends; without it the row is unchanged -->
        <div class="col-12"
          [ngClass]="canDownloadAll ? 'd-flex justify-content-between align-items-center' : 'text-left'">
          <button mat-button (click)="onClose()" mat-raised-button mat-default
            class="ml-3">{{ 'common.cta.close' | translate }}</button>
          <!-- Offered only by the documents page, the one passing the ids the zip endpoint needs -->
          <button *ngIf="canDownloadAll" type="button" mat-raised-button color="primary" class="mr-3"
            [disabled]="zipDownloading" [attr.aria-busy]="zipDownloading" (click)="onDownloadAll()">
            <mat-spinner *ngIf="zipDownloading" diameter="18" class="download-all-spinner mr-2"></mat-spinner>
            <mat-icon *ngIf="!zipDownloading" fontSet="fal" fontIcon="fa-download" class="mr-1"></mat-icon>
            {{ 'properties.documents.downloadDialog.downloadAll' | translate }}
          </button>
        </div> <!-- /.col -->
      </div> <!-- /.row -->
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->